import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SpecFieldNames } from '../../order-builder/modules/specification/constants/specification-field-names.enum';
import { ActionMapInfoTypes } from '../actions/map-info.actions';
import { createReducer, on } from '@ngrx/store';

export interface MapInfo {
    predictions: {
    address: any[];
    isLoading: boolean;
    predictionSelect: {
      value: string;
      data: any;
    };
  };
  formSelected: {
    [SpecFieldNames.ADDRESS]?: string;
    [SpecFieldNames.POINT_OF_DELIVERY_NAME]?: string;
    [SpecFieldNames.ADDRESS2]?: string;
    [SpecFieldNames.CITY]?: string;
    [SpecFieldNames.STATE]?: string;
    [SpecFieldNames.COPY_ADDRESS]?: boolean;
    [SpecFieldNames.ZIP]?: string;
    [SpecFieldNames.ID]?: number;
  };
  controlAddress: any;
  updateValidation?: boolean;
  isCreatingPOD?: boolean;
  hasAcceptedResetWarning?: boolean;
}

export interface MapInfoReducerState extends EntityState<MapInfo> {
  mapInfoVl4: MapInfo;
}

export const adapterMap: EntityAdapter<MapInfo> = createEntityAdapter<MapInfo>({
  selectId: (item) => item?.formSelected?.[SpecFieldNames.ID] || 0,
  sortComparer: false,
});

export const initialStateInfoMap: MapInfoReducerState = adapterMap.getInitialState({
  mapInfoVl4: {
    predictions: {
      address: [],
      isLoading: false,
      predictionSelect: {
        value: null,
        data: null,
      },
    },
    controlAddress: null,
    formSelected: null,
    updateValidation: false,
    isCreatingPOD: false,
    hasAcceptedResetWarning: false,
  },
});

export const infoMapReducer = createReducer(
  initialStateInfoMap,

  on(ActionMapInfoTypes.SetPredictions, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        ...state.mapInfoVl4.predictions,
        address: payload,
      },
    },
  })),
  on(ActionMapInfoTypes.SetIsLoading, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        ...state.mapInfoVl4.predictions,
        isLoading: payload,
      },
    },
  })),
  on(ActionMapInfoTypes.SetControlAddress, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      controlAddress: payload,
    },
  })),
  on(ActionMapInfoTypes.CleanState, (state) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        address: [],
        isLoading: false,
        predictionSelect: {
          value: null,
          data: null,
        },
      },
      controlAddress: null,
      formSelected: null,
      updateValidation: false,
      isCreatingPOD: false,
    },
  })),
  on(ActionMapInfoTypes.CleanPredictionsState, (state) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        ...state.mapInfoVl4.predictions,
        address: [],
      },
    },
  })),
  on(ActionMapInfoTypes.SetPreDictionSelected, (state, { value, data }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        ...state.mapInfoVl4.predictions,
        predictionSelect: {
          value,
          data,
        },
      },
    },
  })),
  on(ActionMapInfoTypes.ClearPredictionSelected, (state) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      predictions: {
        ...state.mapInfoVl4.predictions,
        predictionSelect: {
          value: null,
          data: null,
        }
      },
    },
  })),
  on(ActionMapInfoTypes.UpdateFormSelected, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      formSelected: {
        ...state.mapInfoVl4.formSelected,
        ...payload,
      },
    },
  })),
  on(ActionMapInfoTypes.UpdateValidation, (state, { value }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      updateValidation: value,
    },
  })),

  on(ActionMapInfoTypes.IsCreatingPod, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      isCreatingPOD: payload,
    },
  })),

  on(ActionMapInfoTypes.HasAcceptedResetWarning, (state, { payload }) => ({
    ...state,
    mapInfoVl4: {
      ...state.mapInfoVl4,
      hasAcceptedResetWarning: payload,
    },
  })),
);

export function reducer(state: MapInfoReducerState | undefined, action: any) {
  return infoMapReducer(state, action);
}
